import React, {useEffect, useState} from 'react';
import {NavBar} from 'Components/Nav/NavBar';
import Footer from './Footer';
import s from './styles/CollegeLanding.module.scss';
import {Root} from 'Root';
import Fade from 'react-reveal/Fade'
import arrow_icon from './static/arrow_icon.svg'
import exit_icon from './static/exit_icon.svg'
import sad_icon from './static/sad_icon.svg'
import hero_applicant from './static/hero_applicant.svg'
import background from './static/collegebg.svg'
import {logElementInteraction} from "../../Api/Utils/referral";
import {useLocation} from "react-router-dom";
import {HowThisWorksCard, LargeCollegeCard, MentorCard} from "../../Components/Tile/Card";
import {BACKUP_COLLEGE} from "../Discover/Discover";
import create_profile from './static/create_profile.png'
import accept_requests from './static/accept_requests.png'
import get_paid from './static/get_paid.png'
import find_mentor from './static/find_mentor.png'
import mentoring from './static/mentoring.png'
import transfer from './static/transfer_process.png'
import schedule_chats from './static/schedule_chats.png'
import make_confident_decisions from './static/make_confident_decisions.png'
import {useScroll} from "../../Utils/helpers";
import {getDeviceId} from "../../Utils/sessions";

const APPLICANT_INFORMATION = [
    {icon: "", header: "Find the Right Mentor", details: "Search by university, major, or interests to find a college student who matches your profile.", coverUrl: find_mentor,  linkText: "Begin your search", linkHref: "/register?studentType=PROSPECTIVE"},
    {icon: "", header: "Schedule a 1-on-1 Chat", details: "Book a time that works for you and get ready to ask all your questions—big or small.", coverUrl: schedule_chats,  linkText: "Schedule a chat", linkHref: "/register?studentType=PROSPECTIVE"},
    {icon: "", header: "Choose more confidently:", details: "Get the authentic, unfiltered advice you need to choose the right college and succeed.", coverUrl: make_confident_decisions,  linkText: "Start deciding confidently", linkHref: "/register?studentType=PROSPECTIVE"}
]
const MENTOR_INFORMATION = [
    {icon: "", header: "Create Your Profile", details: "Tell us about your college experience, your major, and what makes your journey unique.", coverUrl: create_profile,  linkText: "Signup in seconds", linkHref: "/register?studentType=CURRENT"},
    {icon: "", header: "Accept Chat Requests", details: "Get notified when a high school student wants your advice. Accept the requests that fit your schedule.", coverUrl: accept_requests,  linkText: "Make yourself available", linkHref: "/register?studentType=CURRENT"},
    {icon: "", header: "Get Paid to Help", details: "Make a real impact on a student's future while earning money for your time and insights.", coverUrl: get_paid,  linkText: "Become impactful", linkHref: "/register?studentType=CURRENT"}
]

const Landing = () => {
    const useQuery = () => {
        return new URLSearchParams(useLocation().search)
    }
    const [applicant, setApplicant] = useState(useQuery().get('type') === 'applicant')
    const [mentorCount, setMentorCount] = useState(null)
    const [collegeCount] = useState(6450)
    const [collegeRepCount, setCollegeRepCount] = useState(null)
    const [displayedMentorCount, setDisplayedMentorCount] = useState(null)
    const [displayedCollegeCount, setDisplayedCollegeCount] = useState(6300)
    const [displayedCollegeRepCount, setDisplayedCollegeRepCount] = useState(null)
    const [trendingColleges, setTrendingColleges] = useState(null)
    const [trendingMentors, setTrendingMentors] = useState(null)

    const defaultMentorCount = 95;
    const defaultCollegeCount = 6300;
    const defaultCollegeRepCount = 60;

    const isScrolled = useScroll(5)

    useEffect(() => {
        logElementInteraction( {
            elementId: 'home::page',
            type: 'VIEW',
            deviceId: getDeviceId(),
            data: localStorage.getItem('userInfo'),
            source: 'WEB'
        }).then(() => {}).catch(() => {});
    }, [])

    useEffect(() => {
        Root.collegeApi.getMentorCount().then(rsp => {
            setMentorCount(Math.floor(rsp.data / 10) * 10)
        }).catch(error => {
            setMentorCount(100)
        })
    }, [])

    useEffect(() => {
        Root.collegeApi.getRepresentedCollegesCount().then(rsp => {
            setCollegeRepCount(Math.floor(rsp.data / 10) * 10)
        }).catch(error => {
            setCollegeRepCount(60)
        })
    }, [])

    useEffect(() => {
         Root.userApi.getDisplayMentors({deviceId: getDeviceId()}).then((res) => {
            setTrendingMentors(res.data)
        }).catch(() => {
            setTrendingMentors([])
        })
    }, [])

    useEffect(() => {
        Root.collegeApi.getDisplayColleges({deviceId: getDeviceId()})
            .then(res => setTrendingColleges(res.data))
            .catch(() => setTrendingColleges(BACKUP_COLLEGE))
    }, [])

    useEffect(() => {
        if (displayedCollegeCount < collegeCount) {
            sleep(5).then(() => setDisplayedCollegeCount(displayedCollegeCount + 1))
        }
    }, [displayedCollegeCount, collegeCount])

    useEffect(() => {
        if (mentorCount && displayedMentorCount < mentorCount) {
            sleep(5).then(() => setDisplayedMentorCount(displayedMentorCount + 1))
        } else if (mentorCount && displayedMentorCount > mentorCount) {
            sleep(5).then(() => setDisplayedMentorCount(displayedMentorCount - 1))
        }
    }, [displayedMentorCount, mentorCount])


    useEffect(() => {
        if (collegeRepCount && displayedCollegeRepCount < collegeRepCount) {
            sleep(5).then(() => setDisplayedCollegeRepCount(displayedCollegeRepCount + 1))
        } else if (collegeRepCount && displayedCollegeRepCount > collegeRepCount) {
            sleep(5).then(() => setDisplayedCollegeRepCount(displayedCollegeRepCount - 1))
        }
    }, [displayedCollegeRepCount, collegeRepCount])

    function sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    function scrollIntoHowThisWorks() {
        const howThisWorksSection = document.getElementById("howThisWorksSection");
        if (howThisWorksSection) {
            howThisWorksSection.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
        }
    }

    return <>
        <div className={s.landing}>
            <div className={`${s.navBarContainer} ${isScrolled ? s.navBarScrolled : ''}`}>
                <NavBar className={s.navBar}/>
            </div>
            <div
                className={s.headerSection}
                style={{
                    backgroundImage: `url(${background})`,
                    backgroundPosition: "center",
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                }}>
                <div className={s.headerSectionContent}>
                    <Fade left>
                        <span className={s.hero}>
                            <h1>
                                <strong>
                                    College decisions <br></br>
                                    are <span style={{color: '#F45728FF'}}>difficult. </span>
                                    Mentors make them <span style={{color: '#8EE3C8'}}>easy.</span>
                                </strong>
                            </h1>

                            <h2 className={s.subtitle}>
                                Your journey to college, guided by those who have been there. Get unfiltered answers and make confident decisions.
                            </h2>

                            <div className={s.searchContainer}>
                              {/*<SearchBar height={'50px'} color="green" text={<FiSearch/>} placeholder="Find your university"/>*/}
                                <button className={s.headerBecomeMentorBtn} onClick={() => {
                                    window.location.href = '/register'
                                }}>
                                    Become a mentor
                                </button>
                                <button className={s.headerFindMentorBtn} onClick={() => {
                                    window.location.href = '/register'
                                }}>
                                    Find your college mentor
                                </button>
                            </div>
                        </span>
                    </Fade>
                    <Fade down>
                        <div className={s.image}>
                            <img style={{width: '90%', objectFit: 'cover'}} src={hero_applicant ?? ''}
                                 alt={'hero image'}/>
                        </div>
                    </Fade>
                </div>
            </div>
            <div className={s.howThisWorksSection} id={'howThisWorksSection'}>
                <div className={s.container}>
                    <h2>How It Works</h2>
                    <h3 className='text-muted'>{applicant ? '3 steps to becoming more confident' : 'Being helpful has never been easier'}</h3>
                    <div className={s.toggleContainer}>
                        <div className={s.toggleWrapper}>
                            <button onClick={() => {
                                setApplicant(!applicant)
                                scrollIntoHowThisWorks()
                            }}
                                    className={`${s.toggleBtn} py-2 px-6 ${applicant ? s.inactiveToggle : s.activeToggle}`}>College
                                Students
                            </button>
                            <button onClick={() => {
                                setApplicant(!applicant)
                                scrollIntoHowThisWorks()
                            }}
                                    className={`${s.toggleBtn} py-2 px-6 ${applicant ? s.activeToggle : s.inactiveToggle}`}>College
                                Applicants
                            </button>
                        </div>
                    </div>

                    <div className={s.howThisWorksCarousel}>
                        {(applicant ? APPLICANT_INFORMATION : MENTOR_INFORMATION).map((info, idx) => {
                            return <HowThisWorksCard key={idx} index={idx} information={info} className={`me-4 my-4`}/>
                        })}
                    </div>
                    <div className={s.growthSectionCtaContainer}>
                        <button className={`${s.growthSectionCta}`} onClick={() => {
                            window.location.href = '/register'
                        }}>
                            {applicant ?
                                'Get started finding a mentor' :
                                'Become a mentor today'
                            }
                        </button>
                    </div>
                </div>
            </div>

            <div className={s.growthSection}>
                <h2>
                    {applicant ?
                        'A platform built for the challenge' :
                        'Join in on the growth & excitement'
                    }
                </h2>
                <h3 className='text-muted'>
                    {applicant ?
                        'Our diverse group of mentors is growing rapidly every day, ready to answer any of your questions.' :
                        'NXSTEP is changing the college decision making process. Join now as a founding college mentor.'
                    }
                </h3>
                <div className={s.growthContainer}>
                    <div className={s.growthCard}>
                        <p className={s.growthCardLabelTop}>We have onboarded over</p>
                        <p className={s.growthCardNumber}
                           data-target="95">{displayedMentorCount ?? defaultMentorCount}+</p>
                        <p className={s.growthCardLabelBottom}>Colleges Mentors</p>
                    </div>
                    <div className={s.growthCard}>
                        <p className={s.growthCardLabelTop}>We have profiles for over</p>
                        <p className={s.growthCardNumber}
                           data-target="6450">{displayedCollegeCount ?? defaultCollegeCount}+</p>
                        <p className={s.growthCardLabelBottom}>Colleges To Discover</p>
                    </div>
                    <div className={s.growthCard}>
                        <p className={s.growthCardLabelTop}>We have mentors at</p>
                        <p className={s.growthCardNumber}
                           data-target="50">{displayedCollegeRepCount ?? defaultCollegeRepCount}+</p>
                        <p className={s.growthCardLabelBottom}>College Across The Nation</p>
                    </div>
                    <button className={s.growthCard} onClick={() => {
                        window.location.href = '/register'
                    }}>
                        <p className={s.growthCardLabelTop}>Getting started is easy</p>
                        <p className={s.growthCardNumber} data-target="20000000">2 min</p>
                        <p className={s.growthCardLabelBottom}>Is All You Need To Sign Up</p>
                    </button>
                </div>

                <div className={s.growthSectionCtaContainer}>
                    <button className={`${s.trendingCollegesCta}`} onClick={() => {
                        window.location.href = '/register'
                    }}>
                        Become a mentor
                    </button>
                    <button className={`${s.trendingCollegesCta}`} onClick={() => {
                        window.location.href = '/register'
                    }}>
                        Find your college mentor
                    </button>
                </div>
            </div>

            <div className={s.trendingCollegesSection}>
                <div className={s.container}>
                    <h2 style={{textAlign: 'center'}}>Discovering colleges can be difficult</h2>
                    <h3 className='text-muted'>{`Ever college is unique, so we'll sort for your perfect match`}</h3>
                    <div className={s.trendingCollegesRow}>
                        <div className='horScroll'>
                            {trendingColleges ? trendingColleges.map((c, idx) => {
                                    return <LargeCollegeCard key={idx} college={c} className='my-4'/>
                                }) :
                                <>
                                    <LargeCollegeCard className='my-4'/>
                                    <LargeCollegeCard className='my-4'/>
                                    <LargeCollegeCard className='my-4'/>
                                    <LargeCollegeCard className='my-4'/>
                                    <LargeCollegeCard className='my-4'/>
                                </>
                            }
                        </div>
                    </div>

                    <div className={s.trendingCollegesCtaContainer}>
                        <button className={`${s.trendingCollegesCta}`} onClick={() => {
                            window.location.href = '/register'
                        }}>
                            Discover the college for you
                        </button>
                    </div>
                </div>
            </div>

            <div className={s.generalInformationSection}>
                <div className={s.generalInformationSectionContainer}>
                    <div className={s.grid}>
                        <div className={'d-flex flex-column justify-content-around'}>
                            <div>
                                <h2>But choosing is even more challenging</h2>
                                <h3 className='text-muted'>Without mentors, it can be like shooting darts in the dark</h3>
                                <div className={s.generalInformationStats}>
                                    <div className={s.generalInformationStat}>
                                        <img style={{height: '4rem'}} className='px-2' src={arrow_icon ?? ''}
                                             alt={''}/>
                                        <span>
                                              <p>35%</p>
                                              <p>of college students transfer at least once</p>
                                            </span>
                                    </div>
                                </div>
                                <div>
                                    <div className={s.generalInformationStat}>
                                        <img style={{height: '4rem'}} className='px-2' src={exit_icon ?? ''}
                                             alt={''}/>
                                        <span>
                                          <p>30%</p>
                                          <p>of college students drop out their first year</p>
                                        </span>
                                    </div>
                                </div>
                                <div>
                                    <div className={s.generalInformationStat}>
                                        <img style={{height: '4rem'}} className='px-2' src={sad_icon ?? ''}
                                             alt={''}/>
                                        <span>
                                              <p>27%</p>
                                              <p>show an increase in symptoms of depression when the wrong college is chosen</p>
                                            </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={`d-flex flex-column justify-content-around`}>
                            <img className={`${s.generalInformationSectionImg}`}
                                 src={transfer ?? ''} alt={''}/>
                        </div>
                    </div>
                    <div className={s.trendingCollegesCtaContainer}>
                        <button className={`${s.becomeMentorBtn}`} onClick={() => {
                            window.location.href = '/register'
                        }}>
                            Start choosing more confidently
                        </button>
                    </div>
                </div>
            </div>

            <div className={s.trendingCollegesSection}>
                <div className={s.container}>
                    <h2 style={{textAlign: 'center'}}>Mentors make it easy</h2>
                    <h3 className='text-muted'>Chat with any of our college mentors to gain an authentic
                        perspective of the life at any
                        college</h3>
                    <div className={s.trendingCollegesRow}>
                        <div className='horScroll'>
                            {trendingMentors ? trendingMentors.map((mentor, idx) => {
                                    return <MentorCard key={idx} mentor={mentor} className={`me-4 my-4`}/>
                                }) :
                                <>
                                    <MentorCard className={`me-4 my-4`}/>
                                    <MentorCard className={`me-4 my-4`}/>
                                    <MentorCard className={`me-4 my-4`}/>
                                    <MentorCard className={`me-4 my-4`}/>
                                    <MentorCard className={`me-4 my-4`}/>
                                    <MentorCard className={`me-4 my-4`}/>
                                    <MentorCard className={`me-4 my-4`}/>
                                    <MentorCard className={`me-4 my-4`}/>
                                </>
                            }
                        </div>
                    </div>
                    <div className={s.trendingMentorsCtaContainer}>
                        <button className={`${s.trendingCollegesCta}`} onClick={() => {
                            window.location.href = '/register'
                        }}>
                            Become a mentor
                        </button>
                        <button className={`${s.trendingCollegesCta}`} onClick={() => {
                            window.location.href = '/register'
                        }}>
                            Find your college mentor
                        </button>
                    </div>

                </div>
            </div>

            <div className={s.generalInformationSection}>
                <div className={s.generalInformationSectionContainer}>
                    <div className={s.grid}>
                    <div className={'d-flex flex-column justify-content-around'}>
                            <div>
                                <h3 className='text-muted'><strong>College Students</strong></h3>
                                <h2 className='mb-3'>Get paid to share your college experience</h2>
                                <p className={s.generalInformationStatement}>Help college applicants learn more
                                    about your university by
                                    chatting
                                    with them over a video call and even through direct messaging, and get paid
                                    while
                                    doing it.</p>
                                <p className={s.generalInformationStatement}>To share even more of your college
                                    story, we encourage you to
                                    also
                                    upload
                                    photos and videos showcasing your school experience. You personal content
                                    provide
                                    valuable
                                    insights to prospective college students.</p>
                            </div>
                        </div>
                        <div className={`d-flex flex-column justify-content-around`}>
                            <img className={`${s.generalInformationSectionImg}`}
                                 src={mentoring ?? ''} alt={''}/>
                        </div>
                    </div>
                    <div className={s.trendingCollegesCtaContainer}>
                        <button className={`${s.becomeMentorBtn}`} onClick={() => {
                            window.location.href = '/register'
                        }}>
                            Get started Mentoring
                        </button>
                    </div>
                </div>
            </div>

            <div className={s.growthSection}>
                <h2>
                    Ready to Find Your Path?
                </h2>
                <h3 className='text-muted'>
                    {`Whether you're looking for guidance or ready to share it, your journey starts here.`}
                </h3>
                <div className={s.lastCallCtaContainer}>
                    <button className={s.becomeMentorBtn} onClick={() => {
                            window.location.href = '/register'
                        }}>
                        Become a mentor
                    </button>
                    <button className={`${s.findMentorBtn} ${s.blackText}`} onClick={() => {
                        window.location.href = '/register'
                    }}>
                        Find your college mentor
                    </button>
                </div>
            </div>
        </div>
        <Footer/>
    </>
};

export default (Landing);
